import styled from 'styled-components';

export const Container = styled.div<{ maxWidth: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${({ maxWidth }) => maxWidth};
  margin: 0 auto;
  padding: 7.5rem 0;
  gap: 15px;
  text-align: center;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 3rem 2rem;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const HighlightLabel = styled.h3`
  font-family: proxima-nova, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
  color: #009fe3;
`;

export const Title = styled.h1`
  font-family: proxima-nova, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 115%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 32px;
  }
`;

export const TitleBlue = styled.span`
  font-family: proxima-nova, sans-serif;
  color: #009fe3;
`;

export const Paragraph = styled.p`
  font-family: proxima-nova, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 16px;
    line-height: 140%;
  }
`;
